import { gql } from '@grandvisionhq/graphql';
import { failureFragment } from '../fragments/failure-fragment.js';

var GET_SHOPPING_LIST_COUNT = gql`
  query GetShoppingListCount($shoppinglistId: String!) {
    shoppinglistById(shoppinglistId: $shoppinglistId) {
      shoppinglist {
        itemsCount
      }
      failure {
        ...ShoppinglistFailureFragment
      }
    }
  }
  ${failureFragment}
`;

export { GET_SHOPPING_LIST_COUNT as default };
//# sourceMappingURL=get-shopping-list-count.js.map
